import React,{useState,useEffect,useCallback,useContext} from "react";

///Styles
import { toast } from "react-toastify";
import {FaSearch} from 'react-icons/fa';
import {Container,Label,ContainerInput,Button} from './styles'

///Components
import { CardInput } from "../../../../inputMasks";
import { Modal } from "../modal";

///Services
import { api } from "../../../../../services/api";
import { MetasContext } from "../goalsContext";



export function GoalsForm(){
    const {saveGoal,search,setSearch,idBusiness,setIdBusiness,dateGoal,setDateGoal,valueGoal,setValueGoal,valueBalancePoint,setValueBalancePoint,setIdMeta} = useContext(MetasContext);


    const [isFocus,setIsFocus] = useState(false);
    const [isShowTable,setIsShowTable] = useState(false)
    const [data,setData] = useState([]);

    const [page,setPage] = useState(20);



    const handleNewBusiness = useCallback(async () => {
        await api.get(`/getBusinessAdm/?quantity=${page}&search=${search}&sync=0`,{
            headers: {
                token: localStorage.getItem('@Inoveclube:token')
            }
        })
        .then((response) => {
            const { business, next_page } = response.data;

            setData(business);
            setPage(p => next_page ? (p + 20) : null);
        })
        .catch((error) => {
            toast.error('Ops, algo deu errado !!')
        })
    },[search,page])

    useEffect(() => {
        async function loadBusiness(){
            await api.get(`/getBusinessAdm/?quantity=20&search=${search}&sync=`,{
                headers: {
                    token: localStorage.getItem('@Inoveclube:token')
                }
            })
            .then((response) => {
                const { business, next_page } = response.data;
                setData(business);
                setPage(p => next_page ? (p + 20) : null);
            })
            .catch((error) => {
                toast.error('Ops, algo deu errado !!')
            })
        }
        loadBusiness()
    },[search]);

    useEffect(() => {
        if(search !== '' && isFocus === true){
            setIsShowTable(true)
        }
        else{
            setIsShowTable(false)
        }
    },[search,isFocus])

    const handleInputFocus = useCallback(() => {
        setIsFocus(true)
    },[]);

    const handleInputBlur = useCallback(() => {
        setIsFocus(false);
    }, []);


    
    function handleValueCurrencyGoal(e){
        let value = e.target.value;
        value = value.replace(/\D/g,'')
        value = value.replace(/(\d)(\d{2})$/,'$1,$2');
        value = value.replace(/(?=(\d{3})+(\D))\B/g, ".");

        setValueGoal(value)
    }

    function handleValueCurrencyBalance(e){
        let value = e.target.value;
        value = value.replace(/\D/g,'')
        value = value.replace(/(\d)(\d{2})$/,'$1,$2');
        value = value.replace(/(?=(\d{3})+(\D))\B/g, ".");

        setValueBalancePoint(value)
    }

    
    async function handleSaveGoal(){
        const month = dateGoal.split('/')[0];

        if(month <= 0 || month > 12){
            toast.error('Por favor, digite uma data válida.');
            return;
        }

        saveGoal(search,idBusiness,dateGoal,valueGoal,valueBalancePoint);
        setSearch('');
        
        setDateGoal('');
        setValueGoal('');
        setValueBalancePoint('');
        setIdBusiness('');
        setIdMeta('');
    }

    
    return(
        <Container>
            <Label>
                <strong>Empresas</strong>
            </Label>

            <ContainerInput>
                <input 
                    type="text" 
                    placeholder="Ex: inove" 
                    className="inputBusiness"
                    onFocus={handleInputFocus}
                    value={search.toUpperCase()}
                    onChange={(event)=>setSearch(event.target.value)}
                />
                <FaSearch/>
            </ContainerInput>

            {
                isShowTable &&
                <Modal
                    business={data}
                    setSearch={setSearch}
                    setIdBusiness={setIdBusiness}
                    handleInputBlur={handleInputBlur}
                    page={page}
                    action={handleNewBusiness}
                />
            }

            <Label>
                <strong>Mês/Ano</strong>
            </Label>

            <ContainerInput>
                <CardInput 
                    placeholder={'MM/AA'}
                    value={dateGoal} 
                    onChange={(event) => setDateGoal(event.target.value)}
                    mask={'99/99'}
                />
            </ContainerInput>

            <Label>
                <strong>Valor Meta</strong>
            </Label>
            <ContainerInput>
                <input 
                    type="text" 
                    placeholder="Ex: R$ 800"
                    value={valueGoal.toLocaleString('pt-Br',{
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    })}
                    onChange={handleValueCurrencyGoal}
                />
            </ContainerInput>

            <Label>
                <strong>Valor Ponto Equilíbrio</strong>
            </Label>
            <ContainerInput>
                <input 
                    type="text" 
                    placeholder="Ex: R$ 800"
                    value={valueBalancePoint.toLocaleString('pt-Br',{
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    })}
                    onChange={handleValueCurrencyBalance}
                />
            </ContainerInput>

            <Button onClick={handleSaveGoal}>Salvar</Button>
        </Container>
    )
}